const SITE_KEY_PROD = "6Lf-fNAZAAAAAL5gloYx7fixhJ-kL5HvZaKQxgLm";
const SITE_KEY_DEV = "6Ldk1doZAAAAAP8qW8J-kIDTbT5OoV1xy2tuy9ji";
const RECAPTCHA_V3_SITE_KEY =
  process.env.RAILS_ENV === "development" ? SITE_KEY_DEV : SITE_KEY_PROD;

export const RECAPTCHA_SIGNUP = "signup";
export const RECAPTCHA_FASTRACK_SIGNUP = "fastrack_signup";
export const RECAPTCHA_CREATE_ADDON = "create_addon";

// actionName is one of [ "signup", "fastrack_signup", "create_addon" ]
export async function getRecaptchaToken(action) {
  if (!window.grecaptcha || process.env.CI) return "";

  return new Promise((resolve, reject) => {
    try {
      window.grecaptcha.ready(async () => {
        const token = await grecaptcha.execute(RECAPTCHA_V3_SITE_KEY, {
          action
        });
        resolve(token);
      });
    } catch (error) {
      reject(error);
    }
  });
}
